import { get } from "./base";
export const getQuestionaries = async (insuredMember) => {
  try {
    const response = await get(
      "/Pacientes/questionaires?insuredMember=" + insuredMember
    );
    const data = await response.data;
    return data;
  } catch (error) {
    console.error("Error retrieving questionaries:", error);
    let data = require("./data/questionnaries.json");
    return data;
  }
};

export const getQuestionaryByType = async (type) => {
  try {
    const response = await get("/Pacientes/questionaires?type=" + type);
    const data = await response.data;
    return data;
  } catch (error) {
    console.error("Error retrieving questionaries:", error);
    let data = require("./data/questionnaries.json");
    return data;
  }
};
